import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

// Components
import { Button, Col, DatePicker, Modal, Row } from 'antd';
// Actions
import { onSetSmartTrainingPeriod } from '../../data/app/actions';
// Selectors
import {
    getSmartTrainingPeriodFrom,
    getSmartTrainingPeriodTo,
} from '../../data/app/selector';
// Other
import { strings } from '../../localization';
import moment from 'moment';
import { MODAL_SIZES } from '../../constants/modal';
import { smartTrainingPeriod } from '../../constants';

function TrainingPeriodSelectModal(props) {
    const {
        periodLength,
        isShown,
        hideModal,
        onSetSmartTrainingPeriod,
        callBack,
        periodFrom,
        periodTo,
    } = props;

    const getTSFromProps = (hours) => moment().valueOf() - (periodLength - hours) * 60 * 60 * 1000;

    const [datePickerStart, setDatePickerStart] = useState(moment(getTSFromProps(periodFrom)));
    const [datePickerEnd, setDatePickerEnd] = useState(moment(getTSFromProps(periodTo)));

    const reactionTime = 2 * 60 * 1000;

    useEffect(() => {
        setDatePickerStart(moment(getTSFromProps(periodFrom)));
        setDatePickerEnd(moment(getTSFromProps(periodTo)));
    }, [periodFrom, periodTo]);


    const disabledStartDate = (startValue) => {
        if (!datePickerEnd) {
            return startValue < moment().subtract(periodLength, 'hours');
        }
        const tooLate = startValue.valueOf() > datePickerEnd.valueOf() + reactionTime; // add reaction time to enable same day by default
        const tooEarly = (startValue.valueOf() < datePickerEnd.valueOf() - smartTrainingPeriod.displayPeriod * 60 * 60 * 1000)
            || (startValue < moment().subtract(periodLength, 'hours'));
        return tooEarly || tooLate;
    };

    const disabledEndDate = (endValue) => {
        if (!datePickerStart) {
            return endValue < moment().subtract(periodLength, 'hours');
        }
        const tooEarly = (endValue.valueOf() < datePickerStart.valueOf() - reactionTime) // let the user pick the same day even with a few minutes less, corrected on submit
            || (endValue < moment().subtract(periodLength, 'hours'));
        const tooLate = endValue.valueOf() > datePickerStart.valueOf() + smartTrainingPeriod.displayPeriod * 60 * 60 * 1000 + reactionTime; // add reaction time to enable last day by default
        return tooEarly || tooLate;
    };

    const clearPickers = () => {
        setDatePickerStart(null);
        setDatePickerEnd(null);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!datePickerStart || !datePickerEnd) {
            return;
        }
        let dateEnd = datePickerEnd;
        if (dateEnd - datePickerStart > smartTrainingPeriod.displayPeriod * 60 * 60 * 1000) {
            // Wrong ending date: > 3/7 days by a few seconds
            dateEnd = datePickerStart + smartTrainingPeriod.displayPeriod * 60 * 60 * 1000;
        }
        if (dateEnd - datePickerStart < 0) {
            // Wrong ending date: ending before the start by a few seconds
            dateEnd = datePickerStart + 60 * 60 * 1000;
        }
        const periodBegin = moment().valueOf() - periodLength * 60 * 60 * 1000;
        onSetSmartTrainingPeriod((datePickerStart.valueOf() - periodBegin) / 3600000, (dateEnd.valueOf() - periodBegin) / 3600000);
        setTimeout(() => {
            callBack(null);
            hideModal();
        }, 300);
        //
    };

    return (
        <div>
            <Modal
                key='training-period-select-modal'
                visible={isShown}
                width={MODAL_SIZES.SMALL}
                title={strings.training.periodPicker}
                onCancel={hideModal}
                onOk={handleSubmit}
                cancelText={strings.cancel}
                okText={strings.save}
            >
                <Row gutter={[1, 1]}>
                    <Col span={4}>{strings.training.from}:</Col>
                    <Col span={15}>
                        <DatePicker
                            disabledDate={(startValue) => disabledStartDate(startValue)}
                            defaultPickerValue={
                                datePickerEnd
                                    ? moment(datePickerEnd)
                                    : periodFrom
                                        ? moment(getTSFromProps(periodFrom))
                                        : null
                            }
                            showTime
                            format='YYYY-MM-DD HH:mm'
                            value={datePickerStart}
                            onChange={(val) => setDatePickerStart(val)}
                        />
                    </Col>
                    <Col span={5}>
                        <Button
                            type='primary'
                            shape='circle'
                            icon='delete'
                            onClick={clearPickers} />
                    </Col>
                </Row>
                <br />
                <Row gutter={[1, 1]}>
                    <Col span={4}>{strings.training.to}:</Col>
                    <Col span={20}>
                        <DatePicker
                            disabledDate={(endValue) => disabledEndDate(endValue)}
                            defaultPickerValue={
                                datePickerStart
                                    ? moment(datePickerStart)
                                    : periodTo
                                        ? moment(getTSFromProps(periodTo))
                                        : null
                            }
                            showTime={
                                {
                                    defaultValue: datePickerStart
                                        ? moment(datePickerStart).subtract(1, 'm')
                                        : null,
                                }
                            }
                            format='YYYY-MM-DD HH:mm'
                            value={datePickerEnd}
                            onChange={(val) => setDatePickerEnd(val)}
                        />
                    </Col>
                </Row>
            </Modal>
        </div>
    );
}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        periodFrom: getSmartTrainingPeriodFrom(state),
        periodTo: getSmartTrainingPeriodTo(state),
    }),
    {
        onSetSmartTrainingPeriod,
    },
)(TrainingPeriodSelectModal);
